
import { defineComponent } from 'vue';
import NavBar from './components/NavBar.vue'
import NeedAlgoSigner from './components/NeedAlgoSigner.vue'
declare var AlgoSigner: any; // eslint-disable-line



export default defineComponent({
    name: 'App',
    components: {
        NavBar,
        NeedAlgoSigner,
    },
    data() {
        return {
            loading: true,
        }
    },
    computed: {
        hasAlgoSigner() {
            return this.$store.state.hasAlgoSigner;
        },
    },
    mounted() {
        this.checkAlgoSigner();
        setTimeout(() => this.loading = false, 200)
    },
    methods: {
        async checkAlgoSigner() {
            if (typeof AlgoSigner !== 'undefined') {
                this.$store.commit('setHasAlgoSigner', true);
                await AlgoSigner.connect();
                this.$store.dispatch('getAll');
            } else {
                setTimeout(() => this.checkAlgoSigner(), 1);
            }
        }
        
    }
});


